import { LOADER_SCRIPT_SOURCES, ScriptSources } from '@sun-finance/utils'
import { ValueProvider } from '@angular/core'

export const enum SupportedScripts {
  SEON = 'seon',
  ZENDESK = 'zendesk',
  GOOGLE_TAG_MANAGER = 'gtm',
  GOOGLE_RECAPTCHA = 'recaptcha',
}

const SCRIPT_SOURCES: ScriptSources = {
  [SupportedScripts.SEON]: { src: 'https://cdn.seondf.com/js/v6/agent.umd.js' },
  [SupportedScripts.ZENDESK]: { src: '/assets/lib/zopim.js' },
  [SupportedScripts.GOOGLE_TAG_MANAGER]: { src: '/assets/lib/gtm.js' },
  [SupportedScripts.GOOGLE_RECAPTCHA]: { src: 'https://www.google.com/recaptcha/api.js?render={siteKey}' },
}

export function provideScriptSources(): ValueProvider {
  return { provide: LOADER_SCRIPT_SOURCES, useValue: SCRIPT_SOURCES }
}
